
(function ($) {
    const sm = 576;
    const md = 768;
    const lg = 992;
    const xl = 1200;

    $(document).on('stafe_mega_menu_responsive_toggle', function (e, toggle) {
        var max = 0;
        $(toggle).parent().children().not('.header-search').each(function () {
            var offset = $(this).offset().top + $(this).height();
            if (offset > max) {
                max = offset;
            }
        })
        $('.stafe-mega-menu').each(function () {
            this.style.setProperty('--top-offset', max + 'px');
        })
    })

    // Permet le déplacement du label si le champs d'un input est rempli
    $(document).on('input', '.form-group input, .form-group textarea, .form-row input, .form-row textarea', function () {
        $(this).toggleClass('has-value', $(this).val().length > 0);
    })
    $('.form-group input, .form-group textarea, .form-row input, .form-row textarea').each(function () {
        $(this).toggleClass('has-value', $(this).val().length > 0);
    })

    $(document).on('click', '.readmore', function () {
        $('ul.wc-tabs a[href="' + $(this).attr('href') + '"]').trigger('click');
    })

    // For each quantity input field on the page
    $(document).on('click', '.quantity.form-group-quantity .plus, .quantity.form-group-quantity .minus', function () {
        // Get the current quantity field
        var qty = $(this).closest('.quantity').find('.qty');
        var val = parseFloat(qty.val());
        var max = parseFloat(qty.attr('max'));
        var min = parseFloat(qty.attr('min'));
        var step = parseFloat(qty.attr('step'));

        if (!step) step = 1;

        // Increment or decrement based on the clicked button
        if ($(this).is('.plus')) {
            if (!isNaN(max)) {
                qty.val(Math.min(max, val + step));
            } else {
                console.log(qty.val());
                qty.val(val + step);
                console.log(qty.val());
                console.log(qty);
            }
        } else {
            if (!isNaN(min)) {
                qty.val(Math.max(min, val - step));
            } else {
                qty.val(val - step);
            }
        }
        qty.trigger('input').trigger('change');
    });

    //------------------------------------------------------
    // Burger Menu
    //------------------------------------------------------
    $('.burger').click(function () {
        $('.burger').toggleClass('clicked');
        $('.header-navigation').toggleClass('show');
        $('body').toggleClass('clicked');
    });

    $(window).resize(function () {
        if ($(window).width() > 1200) {
            $('.burger').removeClass('clicked');
            $('.header-navigation').removeClass('show');
            $('body').removeClass('clicked');
        }
    });

    // Sub-menu
    $('.menu-item-has-children').click(function () {
        if ($(window).width() < 1200) {
            $(this).children('.sub-menu').toggleClass('show');
            $(this).toggleClass('clicked');
            e.preventDefault();
        }
    });

    $(window).resize(function () {
        if ($(window).width() > 1200) {
            $('.sub-menu').removeClass('show');
            $(this).children('.sub-menu').removeClass('show');
            $('.menu-item-has-children').removeClass('clicked');
        }
        $('.menu-item-has-children').click(function () {
            if ($(window).width() < 1200) {
                $(this).children('.sub-menu').toggleClass('show');
                $(this).toggleClass('clicked');
                e.preventDefault();
            }
        });
    });

    // Sticky menu
    $(window).on('scroll', menuScrollRefresh);
    menuScrollRefresh();

    function menuScrollRefresh() {
        const bodyScrollValue = $(window).scrollTop();
        if (bodyScrollValue > 100) {
            $('.header').addClass('scrolled');
        } else {
            $('.header').removeClass('scrolled');
        }
    }

    // Lang Switcher
    const langSwitcher = document.querySelector('.language-switcher');
    const langItems = langSwitcher.querySelectorAll('li');

    langSwitcher.addEventListener('click', (e) => {
        langSwitcher.classList.toggle('open');
    });

    langItems.forEach(item => {
        const link = item.querySelector('a'); // le <a> à l'intérieur du <li>
        link.addEventListener('click', (e) => {
            // Bloquer si le menu n'est pas ouvert ou si c'est la langue actuelle
            if (!langSwitcher.classList.contains('open') || item.classList.contains('current-lang')) {
                e.preventDefault();
            }
        });
    });

// Fermer si clic à l'extérieur
    document.addEventListener('click', (e) => {
        if (!langSwitcher.contains(e.target)) {
            langSwitcher.classList.remove('open');
        }
    });

    // Back to top
    $('.scrolltop').on('click', function() {
        $('html').animate({ scrollTop: 0 }, 'slow');
    })

    $(window).on('scroll', backToTopRefresh);
    backToTopRefresh()
    function backToTopRefresh() {
        const bodyScrollValue = $(window).scrollTop();
        const viewportHeight = $(window).height();
        if (bodyScrollValue > viewportHeight*0.5) {
            $('body > .back-to-top').removeClass('hidden');
        } else {
            $('body > .back-to-top').addClass('hidden');
        }
    }

//------------------------------------------------------
// Modals vidéo fonctionnels
//------------------------------------------------------
    $(document).ready(function () {

        // Ouverture d'une modal au clic sur un item vidéo
        $(document).on('click', '.video_item', function () {
            const modalId = $(this).data('video-modal');
            if (!modalId) return;
            const $modal = $('#' + modalId);
            if (!$modal.length) return;

            const $player = $modal.find('.video_player');
            const videoSrc = $player.data('video-src');
            if (!videoSrc) return;

            // Nettoyer avant injection (sécurité)
            $player.empty();

            // Insérer l'iframe avec autoplay
            $player.html(
                '<iframe src="' + videoSrc + '?autoplay=1" ' +
                'frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
            );

            // Afficher la modal
            $modal.addClass('show');
            $('body').addClass('clicked');

            // Mettre à jour le hash URL si besoin
            history.pushState('', document.title, window.location.pathname + window.location.search + '#' + modalId);
        });

        $(document).on('click', '.closeVideo', function () {
            const $modal = $(this).closest('.modal');
            $modal.removeClass('show');
            $('body').removeClass('clicked');
            $modal.find('.video_player').empty();
            history.pushState('', document.title, window.location.pathname + window.location.search);
        });

        // Fermeture d'une modal au clic sur le bouton close
        $(document).on('click', '.modal .close', function () {
            closeModal($(this).closest('.modal'));
        });

        // Fermeture d'une modal au clic sur le fond
        $(document).on('click', '.modal', function (e) {
            if ($(e.target).hasClass('modal')) {
                closeModal($(this));
            }
        });

        // Fonction pour afficher une modal par ID ou sélecteur
        window.showModal = function(name) {
            let $target = null;

            if (typeof name === 'string' || name instanceof String) {
                $target = $('.modal#modal-' + name);
                if ($target.length === 0) {
                    $target = $(name);
                }
            } else {
                $target = $(name);
            }

            if ($target.length > 0 && $target.hasClass('modal')) {
                $('.modal').removeClass('show');
                $target.addClass('show');
                $('body').addClass('clicked');

                // Mise à jour du hash URL
                history.pushState('', document.title, window.location.pathname + window.location.search + '#' + $target.attr('id'));
            }
        }

        // Fonction pour fermer une modal
        window.closeModal = function(name) {
            let $target = null;

            if (typeof name === 'string' || name instanceof String) {
                $target = $('.modal#modal-' + name);
                if ($target.length === 0) {
                    $target = $(name);
                }
            } else {
                $target = $(name);
            }

            if ($target.length > 0 && $target.hasClass('modal')) {
                $target.removeClass('show');
                $target.find('.video_player').empty(); // supprime iframe pour stopper la vidéo
                $('body').removeClass('clicked');

                // Retirer le hash de l'URL
                history.pushState('', document.title, window.location.pathname + window.location.search);
            }
        }

        // Gérer les modals activées via hash au chargement de la page
        function toggleHashModals() {
            const hash = window.location.hash;
            if (hash) {
                const $modal = $(hash);
                if ($modal.length && $modal.hasClass('modal')) {
                    showModal($modal);
                }
            }
        }

        toggleHashModals();
        $(window).on('hashchange', toggleHashModals);

    });


    //------------------------------------------------------
    // DataLayer
    //------------------------------------------------------

    window.dataLayer = window.dataLayer || [];

    $('#subscribeBtn').on('click', function () {
        window.dataLayer.push({
            'event': 'souscription_en_ligne',
            'formType': 'Abonnement',
        });
    })

    $(document).on('submit', '.section_contact-block form', function () {
        window.dataLayer.push({
            'event': 'formulaire_contact',
            'formType': 'Contactez-nous',
        });
    })

    $('.footer-phone a, header.header.header-slim .header-help a').on('click', function () {
        window.dataLayer.push({
            'event': 'clic-tel',
        });
    })

    $('[data-event]').on('click', function () {
        const event = $(this).data('event');
        if (event && event.length > 0) {
            window.dataLayer.push({
                'event': event
            });
        }
    })

    //------------------------------------------------------
    // Global events
    //------------------------------------------------------

    $(document).on('click', 'button[data-href]', function (e) {
        e.preventDefault();
        const target = $(this).data('target');
        if (target) {
            window.open($(this).data('href'), target);
        } else {
            window.location = $(this).data('href');
        }
    })



    //------------------------------------------------------
    // Stafe blocks JS
    //------------------------------------------------------
    // Divise spacer height
    function resizeSpacers() {
        var isMobile = $(window).width() < 768;

        $('.wp-block-spacer').each(function () {
            var $spacer = $(this);

            // Stocke la hauteur originale une seule fois
            if (!$spacer.data('originalHeight')) {
                $spacer.data('originalHeight', $spacer.outerHeight());
            }

            if (isMobile) {
                $spacer.height($spacer.data('originalHeight') / 2);
            } else {
                $spacer.height($spacer.data('originalHeight'));
            }
        });
    }

    resizeSpacers();
    $(window).on('resize', resizeSpacers);

    // ContentTab
    const sbct_navigation_elements = $('.content-tab_navigation span');
    const sbct_navigation_click = function() {
        const parent = $(this).closest('.content-tab_container');
        if($(this).hasClass('active') || parent.hasClass('animation-running')) return;

        parent.addClass('animation-running');
        var index = $(this).index();
        parent.find('.content-tab_navigation span').removeClass('active');
        $(this).addClass('active');
        sbct_navigation_show(this, index);
    }
    const sbct_debounce = function(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
    const sbct_navigation_show = function (elt, index = 0) {
        const parent = $(elt).closest('.content-tab_container');
        parent.find('.content-tab_group').fadeOut(50, sbct_debounce(function() {
            parent.find('.content-tab_group').eq(index).fadeIn(800, function () {
                parent.removeClass('animation-running');
            });
        }, 1));
    }
    sbct_navigation_elements.eq(0).each(function() {
        $(this).addClass('active');
        sbct_navigation_show(this, 0);
    })
    sbct_navigation_elements.on('click', sbct_navigation_click);

    // ScrollTo anchor
    window.addEventListener("pageshow", function() {
        if (window.location.hash) {
            let element = document.querySelector(window.location.hash);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 300); // Augmenter légèrement le délai si nécessaire
            }
        }
    });

    $(window).on('load', function() {
        // Content Tab
        $('.stafe-blocks-content-tab .content-tab_groups .content-tab_group-items').each(function() {
            new Swiper(this, {
                centeredSlides: true,
                slidesPerView: 1,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        })

        // Carrousel logo
        $('.stafe-blocks-carrousel-logo .carrousel-logo-swiper').each(function() {
            const settings = {
                spaceBetween: 0,
                speed:9000,
                direction: 'horizontal',
                autoplay: {delay: 0},
                loop: true,
                slidesPerView: 2,
                freeMode: true,
                breakpoints: {
                    560: {
                        slidesPerView:  3,
                    },
                    768: {
                        slidesPerView:  2,
                    },
                    1000: {
                        slidesPerView:  1,
                    },
                    1200: {
                        slidesPerView:  3,
                    },
                },
            };

            var swiperLogo = new Swiper(this, settings);
        })

        // Carrousel team
        $('.stafe-blocks-team .team-swiper[data-init-swiper="1"]').each(function() {
            new Swiper(this, {
                slidesPerView: 1,
                spaceBetween: 25,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    560: {
                        slidesPerView:  2,
                    },
                    768: {
                        slidesPerView:  3,
                    },
                },
            });
        })
    });

    // Carrousel Card Push
    $(window).on('load', function() {
        $('.stafe-blocks-card-push .card-push-swiper[data-init-swiper="1"]').each(function() {
            new Swiper(this, {
                slidesPerView: 1,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    768: {
                        slidesPerView:  2,
                    },
                    1200: {
                        slidesPerView: 3,
                    },
                },
            });
        })
    });

    // Carrousel Keynumber
    $(window).on('load', function() {
        $('.stafe-blocks-keynumber .keynumber-swiper[data-init-swiper="1"]').each(function() {
            new Swiper(this, {
                slidesPerView: 2,
                spaceBetween: 30,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    560: {
                        slidesPerView:  3,
                    },
                    768: {
                        slidesPerView:  4,
                    },
                    992: {
                        slidesPerView:  3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                    1400: {
                        slidesPerView: 5,
                    },
                },
            });
        })
    });

    $(window).on('load', function() {
        $('.stafe-blocks-video .video-swiper[data-init-swiper="1"]').each(function() {
            new Swiper(this, {
                direction: 'vertical',
                slidesPerView: 2,
                spaceBetween: 25,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    0: {
                        direction: 'horizontal',
                        slidesPerView: 1,
                    },
                    560: {
                        direction: 'horizontal',
                        slidesPerView: 2,
                    },
                    992: {
                        direction: 'vertical',
                        slidesPerView: 2,
                    }
                }
            });
        });
    });

    // Accordéon
    $('.accordion_item').on('click', function () {
        const wrapper = $(this).parent();
        const isOpen = $(this).hasClass('open');
        wrapper.find('.accordion_item').removeClass('open');
        wrapper.find('.accordion-title').removeClass('open');
        wrapper.find('.accordion-content').slideUp();
        if (!isOpen) {
            $(this).addClass('open');
            $(this).children('.accordion-title').addClass('open');
            $(this).children('.accordion-content').slideToggle();
        }
    });

    /* --- ANIMATIONS --- */
    // Global
    $(document).ready(function() {
        $(window).scroll( function(){
            $(".translate").each(function(i) {
                var position_element = $(this).offset().top;
                var position_window = $(window).scrollTop() + $(window).height();

                if ( position_element < position_window ) {
                    $(this).addClass("show")
                }
                else if ( position_element > position_window ) {
                    $(this).removeClass("show")
                }
            })
        });
    });

    // Parallax

    document.querySelectorAll(".stafe-blocks-content, .stafe-blocks-banner").forEach((block) => {
        const floatItems = block.querySelectorAll(".content-block_container .floating-img-item, .banner-block_container .slider-floating-item");
        block.addEventListener("mousemove", function(event) {
            floatItems.forEach((shift) => {
                const position = parseFloat(shift.getAttribute("value") || 1);
                const x = (window.innerWidth - event.pageX * position) / 90;
                const y = (window.innerHeight - event.pageY * position) / 90;
                shift.style.transition = "transform 0.2s ease";
                shift.style.transform = `translateX(${x}px) translateY(${y}px)`;
            });
        });
        block.addEventListener("mouseleave", function() {
            floatItems.forEach((shift) => {
                // Retour smooth au repos
                shift.style.transition = "transform 0.6s ease";
                shift.style.transform = "translateX(0px) translateY(0px)";
            });
        });
    });

    $('.page-content > section:first-of-type .translate').addClass('show');

})(jQuery);